/**
 * Constants configuration.
 */
export const ACCEPTED_DOCUMENT_TYPES =
  '.csv, .doc, .docx, .jpeg, .jpg, .pdf, .xls, .xlsx, application/msword, application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocumen spreadsheetml.sheet, application/vnd.openxmlformats-officedocumen wordprocessingml.document, image/jpeg, text/csv'

export const CLAIM_TYPES = {
  LATE_PAYMENT: 1,
  PROCUREMENT_IRREGULARITY: 2
}

export const MAX_MB = 20

export const SNACKBAR_CLOSE_TIMEOUT = 5000
